/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

const FcsPermissionHorde = {
  dhl_first_mile_client_whitelist: new FcsFlag.Flag(false)
};

export const FlagsPermissionHorde = {
  ...FcsPermissionHorde
};

export function initFlagsHorde() {
  FcsFlag.register("horde", FcsPermissionHorde);
}
